<template>
	<div>
		<div class="list-btn">
			<Button type="primary" @click="add()">新增</Button>
		</div>
		<div class="query">
			<div class="checkbox">

			</div>
			<Input search enter-button placeholder="请输入地址/名称查询" v-model="query.like" style="width: 500px;" @on-search="onsearch"   />
		</div>
		<Table border :columns="columns12" :data="data6" :loading="loading">
			<template slot-scope="{ row, index }" slot="action">
				<Button type="primary" size="small" style="margin-right: 5px" @click="update(row.id)">详情</Button>
				<Button @click="forbidden1(row.id)" size="small" style="margin-right: 5px" class="delete">重置密码</Button>
				<Modal v-model="modal3" width="360">
					<p slot="header" style="color:#f60;text-align:center">
						<Icon type="ios-information-circle"></Icon>
						<span>重置密码</span>
					</p>
					<div style="text-align:center">
						<p>确定重置密码？</p>
					</div>
					<div slot="footer">
						<Button type="error" size="large" long :loading="modal_loading3" @click="updtePassword()">确定</Button>
					</div>
				</Modal>
				<Button @click="forbidden(row.id)" size="small" style="margin-right: 5px" class="delete">禁用/启用</Button>
				<Modal v-model="modal2" width="360">
					<p slot="header" style="color:#f60;text-align:center">
						<Icon type="ios-information-circle"></Icon>
						<span>修改状态</span>
					</p>
					<div style="text-align:center">
						<p>确定修改？</p>
					</div>
					<div slot="footer">
						<Button type="error" size="large" long :loading="modal_loading" @click="updteState()">确定</Button>
					</div>
				</Modal>
			</template>
		</Table>
		<div class="my-page">
			<page :total="total" v-if="showPage" @updatePage="updatePage" @updateSize="updateSize"></page>
		</div>
	</div>
</template>
<script>
	import http from '@/http/http.js'
	import page from '@/components/comm/page.vue'
	export default {
		data() {
			return {
				showPage:true,
				loading: false,
				total: 0,
				query: { //查询参数
					page: 0,
					size: 10,
					jmType:'FACILITY',
					like:''
				},
				modal2: false,
				modal_loading: false,
				modal3: false,
				modal_loading3: false,
				deleteId: '',
				columns12: [
					// {
					// 	title: '图片',
					// 	key: 'imgUrl',
					// 	width: 136,
					// 	render: (h, params) => {
					// 		const row = params.row;
							
					// 		return h('div', [
					// 			h('img', {
					// 				style: {
					// 					width: "100px",
					// 					height:'100px',
					// 					verticalAlign: "middle"
					// 				},
					// 				attrs: {
					// 					src: params.row.imgUrl
					// 				}
					// 			}, )
					// 		]);
					// 	}
					// },
					{
						title: 'id',
						key: 'id',
						width:120,
						align: 'center',
					},
					{
						title: '姓名',
						key: 'name',
						width:150,
						align: 'center',
					},
					{
						title: '联系方式',
						key: 'phone',
						width:150,
						align: 'center',
					},
					{
						title: '区域',//
						key: 'region',
						width:150,
						align: 'center',
						render: (h, params) => {
							return h("div", params.row.region.mergerName )
						}
					},
					{
						title: '住址',
						key: 'address',
						width:150,
						align: 'center',
					},
					{
						title: '状态',
						key: 'state',
						width:100,
						align: 'center',
						render: (h, params) => {
							if(params.row.state==true){
								return h("div",{style:{color:'green'}},"启用") 
							}else{
								return h("div",{style:{color:'red'}},"禁用") 
							}
						}
					},
					{
						title: '录入时间',
						key: 'createdTime',
						width:150,
						align: 'center',
					},
					{
						title: '操作',
						slot: 'action',
						width: 300,
						align: 'center'
					}
				],
				data6: [
					/* 	{
						id: '1',
						companyName: '',
						address: '',
						phone1: '',
						phone2: '',
						phone3: '',
						mailbox: '',
						operType: '',
						state: '',
						createdTime: '2010-10-10'

					}, */
				]

			}
		},
		methods: {
			
			onsearch(){
				let _this=this
				_this.query.page=0
				
				//重新渲染子组件
				this.showPage = false
				this.$nextTick(() => {
					this.showPage = true
				}) 
				_this.ajaxPage()
			},
			ret() { //返回上一页
				this.$router.go(-1)
			},
			update(id) { //修改
				this.$router.push({
					name: 'jm/platform/fac/update',
					query: {
						id: id
					}
				})
			},
			forbidden(id) {
				this.deleteId = id
				this.modal2 = true
			},
			forbidden1(id) {
				this.deleteId = id
				this.modal3 = true
			},
			add() {
				this.$router.push({
					name: 'jm/platform/fac/add'
				})
			},
			updteState() {
				let _this=this
				if (this.deleteId == "") {
					this.$Message.error('参数错误，请刷新页面后重试!');
				} else {
					http.http({
					    //这里是你自己的请求方式、url和data参数
					    method: 'post',
					    url: http.url + '/plat/jm/emp/update/state',
					    data: {id: _this.deleteId},
						_this: _this,
						success: function(data) {
							_this.modal_loading = false;
							_this.modal2 = false;
							_this.$Message.success('修改成功！！！');
							_this.ajaxPage()
						}
					    //假设后台需要的是表单数据这里你就可以更改
					  })
					
				}
			},
			updtePassword() {
				let _this=this
				if (this.deleteId == "") {
					this.$Message.error('参数错误，请刷新页面后重试!');
				} else {
					
					http.http({
					    //这里是你自己的请求方式、url和data参数
					    method: 'post',
					    url: http.url + '/plat/jm/emp/update/password',
					    data:  {id: _this.deleteId},
						_this: _this,
						success: function(data) {
							_this.modal_loading3 = false;
							_this.modal3 = false;
							_this.$Message.success('修改成功！！！');
							_this.ajaxPage()
						}
					    //假设后台需要的是表单数据这里你就可以更改
					  })
					
					
				}
			},
			updatePage(page) { //页码改变的回调，返回改变后的页码
				this.query.page = page - 1
				this.ajaxPage()
			},
			updateSize(size) { //切换每页条数时的回调，返回切换后的每页条数
				this.query.size = size
				this.ajaxPage()
			},
			ajaxPage() {
				let _this=this
				this.loading = true
				http.http({
				    //这里是你自己的请求方式、url和data参数
				    method: 'post',
				    url: http.url + '/plat/jm/emp/page',
				    data: _this.query,
					_this: _this,
					success: function(data) {
						_this.total = data.empPage.totalElements
						_this.data6 = data.empPage.content
						
						_this.loading = false
					}
				    //假设后台需要的是表单数据这里你就可以更改
				  })
				
			}

		},
		components: {
			page
		},
		created() {
			this.ajaxPage();
		}


	}
</script>
<style scoped="scoped">
	.ivu-table-cell {
		padding-left: 0px !important;
	}

	.list-btn {
		margin-bottom: 20px;
	}

	.delete {
		/* background-color: red;
		color: #333333; */
	}

	.my-page {
		display: flex;
		justify-content: flex-end;
		margin-top: 20px;
	}

	.ivu-table-cell {
		padding-left: 0px;
	}

	.query {
		display: flex;
		justify-content: space-between;
		margin: 20px 0px 20px 0px;
	}
</style>



// WEBPACK FOOTER //
// src/components/jm/platform/facility/list.vue